(function() {
    'use strict';

    /** *DO NOT USE* - Destined to be used when a dynamic block cannot be rendered for some reason. */
    angular.module( APP_ID )
        .component( 'contentBlank', {
            bindings: {
                content: '<',
                type:    '<'
            },
            controller: [ 'LoggerFactory', function( LoggerFactory ) {

                // Helping members.

                /** @type {angular.IController} */
                var vm = this;

                /** @type {Logger} */
                var logger = LoggerFactory.createLogger( 'ContentBlankComponent', false );


                /** @constructor */
                vm.$onInit = function() {
                    logger.warn( "Cannot render dynamic block `%s`, leaving it blank...", vm.type, vm.content );
                }
            }],
            controllerAs: 'vm'
        });
})();
